import React, { useState } from "react";
import { Button } from "../../common/button";
import ZapierLogo from "V2.0/images/zapier.svg";

function ZapierComponent({isViewOnly}) {
  const redirectToFacebook = () => {
    window.open(
      "https://zapier.com/developer/public-invite/223693/86f17070c69fa1717ba6bc9b9e38703d/",
      "_blank"
    );
  };

  return (
    <div>
      <div class="flex flex-col items-center">
        <div className="w-full max-w-md px-4 py-10 sm:px-6 lg:px-8 lg:py-6 border rounded-lg">
          <div className="flex items-center gap-x-2">
            <img
              src={ZapierLogo}
              width={30}
            />
            <h3 className="text-base font-semibold leading-6 text-gray-900">
              Zapier
            </h3>
          </div>
          <div className="mt-2 text-sm text-gray-500">
            <p>Automate your workflows using Zapier</p>
            {!isViewOnly && <Button
              className="mt-5"
              onClick={redirectToFacebook}
            >
              Connect Zapier
            </Button>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ZapierComponent;
